import * as React from 'react'
import { Typography } from '@material-ui/core'
import { styled as muiStyled, useTheme } from '@material-ui/core/styles'
import styled from 'styled-components'
import { Divider } from 'components/atomic/standalone/atoms/Divider'

type Props = {
  title: string
  size?: 'small' | 'medium'
}

export const Title: React.FC<Props> = ({ size = 'medium', title }) => {
  let variant: 'h1' | 'h2' = 'h1'
  if (size == 'small') variant = 'h2'

  const { palette } = useTheme()

  return (
    <Block>
      <Text variant={variant} align="center">
        {title}
      </Text>
      <Divider color="common.black" edgeType="square" />
    </Block>
  )
}

const Block = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`
const Text = muiStyled(Typography)(({ theme: { palette } }) => ({
  marginBottom: '13px',
  color: palette.text.primary,
  lineHeight: '150%',
}))

export default Title
